import useAppStore from "@/context/store";
import { getParentAttribute } from "@/utils/getParent";
import Router from "next/router";

export function getFilter(page_nm, targetNode = {}) {
  const filter_one = getAttribute(targetNode, "data-filter-one") || [];
  const filter_two = getAttribute(targetNode, "data-filter-two") || [];

  if (page_nm === "发现页" || page_nm === "ai圈页面") {
    const activeFilter = document.getElementById("active-filter-item");

    if (!activeFilter) {
      return {};
    }
    filter_one.push(activeFilter.innerText);
  }
  if (page_nm === "热点日历聚合页") {
    const filterOne = document.getElementById("active-filter-one")?.innerText;
    const filterTwo = document.getElementById("active-filter-two")?.innerText;
    filter_one.push(filterOne);
    filter_two.push(filterTwo);
  }
  if (page_nm === "搜索结果页") {
    const { type, category } = Router.router.query;

    switch (type) {
      case "board":
        filter_one.push("画板");
        break;
      case "user":
        filter_one.push("用户");
        break;
      case "pin":
        filter_one.push("采集");
        // 二级筛选项_分类信息
        filter_two.push(
          useAppStore
            .getState()
            .categories.find((item) => item?.id === category)?.name || "全部"
        );
        break;
      case "material":
        filter_one.push("素材");
        break;
      case "aigc":
        filter_one.push("aigc");
        break;
      default:
        // 默认采集搜索情况
        if (document.querySelector(".ant-tabs-tab-active")) {
          filter_one.push(
            document.querySelector(".ant-tabs-tab-active").children[0].innerText
          );
          // 二级筛选项_分类信息
          filter_two.push(
            useAppStore
              .getState()
              .categories.find((item) => item?.id === category)?.name || "全部"
          );
        }
        break;
    }
  }
  if (page_nm === "花瓣素材首页") {
    return {};
  }

  return {
    filter_one: filter_one.length ? filter_one : "",
    filter_two: filter_two.length ? filter_two : "",
  };
}

/**
 * 获取参数，从此节点往父元素进行遍历获取
 * @param {Element} element
 * @param {string} attribueName
 */
export function getAttribute(element, attribueName) {
  return (
    element.getAttribute?.(attribueName) ||
    getParentAttribute(element, attribueName)
  );
}
